import script from "./NotificationToast.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationToast.vue?vue&type=script&setup=true&lang=js"

import "./NotificationToast.vue?vue&type=style&index=0&id=7ebdaa7e&scoped=true&lang=scss"

import exportComponent from "/Users/alex/lab_dev_test/info-global/info_front_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ebdaa7e"]])

export default __exports__